export const css = {
    welcome: '_2J7hVBV-',
    skip: 'EU0JrPKZ',
    ' _key': 'certwise-theme/certwise/landing-page/welcome-view'
};
export default css;
